// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeviceIcon__container-ce43cc {
  position: relative;
}

.DeviceIcon__statusIcon-dabf6e {
  background-color: var(--base-80);
  fill: var(--color-icon-default);
  width: 16px;
  height: 16px;
  position: absolute;
  inset-inline-end: 0px;
  bottom: 0px;
  padding: 4px;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Device/DeviceIcon/DeviceIcon.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,gCAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  position: relative;\n}\n\n.statusIcon {\n  background-color: var(--base-80);\n  fill: var(--color-icon-default);\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  inset-inline-end: 0px;\n  bottom: 0px;\n  padding: 4px;\n  border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeviceIcon__container-ce43cc`,
	"statusIcon": `DeviceIcon__statusIcon-dabf6e`
};
module.exports = ___CSS_LOADER_EXPORT___;
